module.exports = __webpack_public_path__ + "static/media/System_Setup.ad21e31f.svg";